export default __webpack_public_path__ + "static/media/8c.a43b2b22.png";